import React, {useEffect} from "react";
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import {PATH} from "../routes/routes";
import {clearStorageItems, getAppLocale, handleAppVersionUpdate} from "../util/common";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function TableQrScan(props) {

    const navigateTo = useNavigate();

    const {shopName, userTable} = useParams();
    const decodedUserTable = decodeURIComponent(userTable);
    const userTableStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) : null;
    const shopNameStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) ? StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) : null;
    const localeStorage =  StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE) : null;
    useEffect(() => {

        handleAppVersionUpdate();
        if (decodedUserTable !== userTableStorage || shopNameStorage !== shopName || getAppLocale() !== localeStorage) {
            clearStorageItems();
            StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
            StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_NAME, shopName);
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TABLE, decodedUserTable);

        }

        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.TABLE);
        StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "false");
        navigateTo(PATH.ALL_PRODUCTS);

    }, []);

    return (
        <div className="redirect-msg">
            Loading Zoniz Ordering App...
        </div>


    );
}

export default TableQrScan;
